import { SEARCH_SUGGESTIONS_LISTBOX_ID } from './constants';

export const getSearchSuggestionOptionId = (navigationIndex: number) =>
  `${SEARCH_SUGGESTIONS_LISTBOX_ID}-option-${navigationIndex}`;
